<template>
    <div class="register">
        <van-form>
            <van-cell-group class="required">
                <van-field
                    v-model="user.realname"
                    name="realname"
                    placeholder="请输入姓名"
                />
            </van-cell-group>
            <van-cell-group v-if="!bindStatus" class="required">
                <van-field
                    v-model="user.mobile"
                    name="mobile"
                    placeholder="请输入手机号"
                />
                 <button class="sendCode" @click="sendCode">{{sendTimeText}}</button>
            </van-cell-group>
            <van-cell-group v-if="!bindStatus" class="required">
                <van-field
                    v-model="user.msgcode"
                    name="msgcode"
                    placeholder="请输入验证码"
                />
            </van-cell-group>
            <van-cell-group>
                <van-field
                    v-model="user.email"
                    name="email"
                    placeholder="请输入邮箱"
                />
            </van-cell-group>
            <van-cell-group class="required">
                <van-field
                        v-model="user.hospital_name"
                        name="hospital_name"
                        placeholder="请输入单位"
                />
            </van-cell-group>
            <van-cell-group class="required">
                <van-field
                    v-model="user.department"
                    name="department"
                    placeholder="请输入科室"
                />
            </van-cell-group>
            <van-cell-group>
                <van-field
                readonly
                clickable
                name="area"
                :value="areavalue"
                placeholder="点击选择省市区"
                @click="showArea = true"

                />
            </van-cell-group>
            <van-cell-group class="address_info">
                <van-field
                    v-model="user.address_info"
                    name="address_info"
                    placeholder="请输入详细地址"
                />
            </van-cell-group>
			<van-popup v-model="showArea" position="bottom">
                <van-area
                    :area-list="areaList"
                    @confirm="onConfirm"
                    @cancel="showArea = false"

                />
			</van-popup>
            <div class="buttonGroup" ref='buttonGroup'>
               <van-button type="default" @click="$router.go(-1)">取消</van-button>
               <van-button type="default" @click="onSubmit">确定</van-button>
              
            </div>
        </van-form>
        <van-popup v-model="sucShow" position="center"   class="success" round :close-on-click-overlay="closeOverlay" >
			<div>
				<img src="../../assets/images/filloutSuccess.png" alt="" >
                <h1>您已成功提交信息</h1>
                <p>前100名注册用户将获得一份精美礼品</p>
				
			</div>
		</van-popup>
       
        <p class="state">注意 :<span> * </span>为必填项</p>
    </div>
</template>  
<script>
    import {Register,SendCode,BindMobile,PersoanalUserInfo}  from '../../config/interface.js'
    import Areas from '../../assets/js/area.js'
    let codeTimer;
    export default {
        data(){
            return{
                bindStatus:true,
                closeOverlay:false,
                sucShow:false,    //信息注册成功
				areavalue: '',
                showArea: false,
                parent_id:0,    //默认0   请求的是省份
                areaList:Areas, // 数据格式见 Area 组件文档
                isReSend:true,   //是否重新发送
                countdown:60,     //倒计时
                sendTimeText:'获取验证码',
                user:{
                    realname:'',
                    mobile:'',
                    msgcode:'',
                    email:'',
                    hospital_name:'',
                    department:'',
                    address_province_id:'',
                    address_city_id:'',
                    address_district_id:'',
                    address_info:''
                }
            }
		},
		mounted(){
          this.getUserInfo();
          common.changePosition(this.$refs.buttonGroup);
		},
        methods:{
            //得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.bindStatus=data.mobile==null?false:true;
                    }
                })
            },
            //验证手机号
			verifyMobile(){
				let mobile=this.user.mobile;
				if(mobile==''){
					common.toast('请输入手机号',1000)
				}else if(!(/^1[3456789]\d{9}$/.test(mobile))){
					common.toast('请输入正确的手机号',1000)
				}else{
					return true;
				}
				return false;
            },
            //点击发送验证码
			sendCode(){
				if(this.isReSend&&this.verifyMobile()){
					this.getCode();
					this.isReSend=false;
				}
            },
            //得到验证码
			getCode(mobile){
				this.sendTime();
				const url=SendCode;
				const method='POST';
				let params={
					mobile:this.user.mobile,
					type:1    //为1时是重置密码
				}
				fetch(url,params,method)
				.then((res)=>{
					console.log(res.code);
					if(res.code==0){
						common.toast('发送成功',1000)
					}else{
						
					}
				})

			},
			sendTime(){
				if(this.countdown==1){
					this.clearCodeTimer();
					return;
				}else{
					this.countdown--;
					this.sendTimeText='重新发送('+this.countdown+')s';
				  	codeTimer=setTimeout(()=>{
				  		setTimeout(this.sendTime(), 1000);
				  	}, 1000)
				}
			},
			//清除定时器
			clearCodeTimer(){
				clearTimeout(codeTimer);
				this.isReSend=true;
				this.sendTimeText="获取验证码";
				this.countdown=60;
			},
			onConfirm(array) {
				this.areavalue = array.map((item) => item.name).join('/');
                this.showArea = false;
                this.user.address_province_id=array[0].code;
                this.user.address_city_id=array[1].code;
                this.user.address_district_id=array[2].code;
            },
            onSubmit(){
                var emailreg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
                if(this.user.realname==''){
                    common.toast('请输入姓名',1000)
                }else if(!this.bindStatus&&!this.verifyMobile()){
                    
                }else if(this.user.msgcode==''&&!this.bindStatus){
                    common.toast('请输入验证码',1000)
                }else if(this.user.hospital_name==''){
                    common.toast('请输入单位',1000)
                }else if(this.user.department==''){
                    common.toast('请输入科室',1000)
                }else{
                    const url=this.bindStatus?Register:BindMobile;
                    let params=this.user;
                    console.log(params);
                    const method='POST';
                    fetch(url,params,method)
                    .then((res)=>{
                        if(res.code==0){
                            this.sucShow=true;
                            setTimeout(()=>{
                                 this.$router.go(-1)
                            },2000)
                        }
                    })
                }
                

            }
        }
    }
</script>
<style lang="scss" scoped>
   .register{
	   padding:30px 15px;
       box-sizing: border-box;
       .close{
           position:absolute;
           top:10px;
           right:10px;
           font-size:20px;
       }
       h2{
           font-size:20px;
           color:#901d22;
           text-align: center;
           margin-bottom:20px;
       }
       .van-cell-group{
           display:flex;
           align-items: center;
		   font-size:15px;
           margin-bottom:15px;
           .van-cell{
                // border:1px solid #ddd;
               background:rgba(86,86,86,0.03);
               border-radius:10px;
               padding:10px 15px;
           }
           .van-cell:not(:last-child)::after{
               border:0px;
           }
       }
       .van-cell-group.address_info{
           margin-bottom:7px;
       }
       .van-cell-group:before{
            display:inline-block;
            vertical-align:middle;
            content:'*';
            margin-right:5px;
            color:#fff;
       }
       .van-cell-group.required:before{
               color:red;
        }
        .van-cell-group:after{
            border:0px;
        }
       button.sendCode{
            border-radius:0 10px 10px 0;
            font-size:12px;
            width:140px;
			border:0px;
			color:$color-main;
			background:#fff;
			// border-left:1px solid $color-main;
       }
       .buttonGroup{
           width:100%;
           position: absolute;
           bottom:15px;
           left:0px;
           display: flex;
           justify-content: space-around;
           button{
            width:134px;
            height:40px;
            color:#fff;
            background:rgba(154,154,154,1);
            border-radius:23px;
            font-size:17px;
           }
           button:last-child{
               background:#901D22;
           }
       }
       .success{
           padding:35px 15px;
           text-align: center;
           img{
               width:7rem;
           }
           h1{
               margin:0 0 10px;
               font-size:17px;
               letter-spacing: 1px;
               color:#090909;
           }
           p{
               color:#999;
               font-size:13px;
           }
       }
       .state{
           margin-left:10px;
           span{
               color:red;
           }
       }

   } 
</style>  


// WEBPACK FOOTER //
// src/pages/User/register.vue